import {
  BarChart3, Building2, Calendar, Filter, Globe, Handshake, Landmark, Layers,
  Receipt, RotateCcw, ScanLine, Send, Shield, ShoppingBasket, Shuffle, Smartphone,
  Tag, Truck, Users, Wallet, type LucideIcon,
} from 'lucide-react';

/**
 * Zone 3's icons.
 *
 * A row of three identical ticks is what the design's outlined-icon squares
 * were there to replace: three sentences all badged the same way read as a
 * checklist, and the whole point of that zone is that they are three different
 * kinds of claim.
 */
export const POINT_ICONS = {
  globe: Globe,
  wallet: Wallet,
  send: Send,
  users: Users,
  building: Building2,
  layers: Layers,
  shuffle: Shuffle,
  chart: BarChart3,
  phone: Smartphone,
  scan: ScanLine,
  calendar: Calendar,
  shield: Shield,
  tag: Tag,
  basket: ShoppingBasket,
  receipt: Receipt,
  filter: Filter,
  bank: Landmark,
  ledger: Receipt,
  refund: RotateCcw,
  truck: Truck,
  handshake: Handshake,
} satisfies Record<string, LucideIcon>;

export type PointIcon = keyof typeof POINT_ICONS;
